import EgamingStats from "./EgamingStats";

export default EgamingStats;
